import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/store';
import { userLogout } from '@/store/auth/action';
import { ReactComponent as UserLine } from "@/assets/icons/user-line.svg";
import { ReactComponent as LogoutBoxRLine } from "@/assets/icons/logout-box-r-line.svg";
import { ReactComponent as NotificationLine } from "@/assets/icons/notification-line.svg";
import Modal from '@/components/common/Modal';
import { renderNotificationHeader, renderNotificationBody } from '@/components/common/UserInfo/Notifications';

const handleLogout = async (dispatch) => {
  await dispatch(userLogout({})).then(async (res) => {
    if (!res.error) {
      window.location.replace('/login')
    }
  })
}

const UserInfo = ({ unreadNotification, notificationItem, currentUser }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [show, setShow] = useState(false)
  const [showNotification, setShowNotification] = useState(false)
  const closeModal = () => {
    setShow(false)
  }

  useEffect(() => {
    setShowNotification(unreadNotification)
  }, [unreadNotification])
  return (
    <div className='w-full flex flex-col px-6 gap-4 my-6'>
      <div className='w-full flex flex-row gap-4'>
        <div className='bg-red-primary p-3 text-white rounded'>
          <UserLine />
        </div>
        <div className='flex flex-col gap-2'>
          <div className='text-jsm font-bold text-white'>{currentUser?.name}</div>
          <div className='text-jxs text-grey-dark'>{currentUser?.role?.name}</div>
        </div>
        <div onClick={() => setShow(true)}
             role='button'
             tabIndex={0}
             onKeyDown={() => {
             }}
             className='ml-auto flex relative items-center justify-center text-grey-dark'>
          <NotificationLine />
          <div className='absolute top-0 right-0 mt-2 -mr-1'>
            {!!showNotification && <div className='w-2 h-2 bg-red-primary rounded-full' />}
          </div>
        </div>
      </div>
      <div onClick={() => handleLogout(dispatch)}
           role='button'
           tabIndex={0}
           onKeyDown={() => {
           }}
           className='rounded w-full flex flex-row items-center justify-start bg-grey-darkest gap-2.5 px-4 py-3 text-white cursor-pointer'>
        <div>
          <LogoutBoxRLine />
        </div>
        <div>Log Out</div>
      </div>
      { show && <Modal show={show}
											 header={renderNotificationHeader}
											 body={renderNotificationBody(notificationItem, navigate, dispatch, setShow)}
											 onClick={() => closeModal}
											 rootId="portal-notification"/> }
    </div>
  );
}

export default UserInfo;
